import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { IServiceCatalog, ServiceCatalogRequest } from "../library/models/serviceCatalog";
import { BaseService } from "./baseService";

/**
 * The clinic's published price list.
 *
 * Neither call names a clinic: the API takes it from the session, so this returns the
 * caller's own catalogue and writes to nobody else's. Reading needs any signed-in
 * member; writing is the clinic admin's alone, and the API answers 403 either way rather
 * than trusting the button to have been hidden.
 */
export class ServiceCatalogService extends BaseService {
    getServiceCatalog(): UseQueryOptions<IServiceCatalog, Error> {
        return this.createGetQuery<IServiceCatalog>('/service-catalog');
    }

    /**
     * Sends the whole catalogue, not a patch: whatever is absent is removed, and order is
     * the order of the lists. Hand-written rather than built with createMutation, which
     * only speaks POST/PATCH/DELETE shapes.
     *
     * Resolves with the stored result, so the caller can render what was actually saved
     * instead of trusting its own draft.
     */
    saveServiceCatalogMutation(): UseMutationOptions<IServiceCatalog, Error, ServiceCatalogRequest> {
        return {
            mutationFn: (payload: ServiceCatalogRequest): Promise<IServiceCatalog> =>
                this.put<IServiceCatalog>('/service-catalog', payload),
        };
    }
}
